import styled from 'styled-components';

const Chevron = styled.img`
    width: 24px;
    height: 24px;
    transform: rotate(${props => props.left ? `180deg` : `-180eg`});
`

export default Chevron;